const SgiOverlapEO = function () {
    return {
        cId: "",
        ctlN: "新层叠面板",
        ctlH: '100%',
        ctlW: '100%',
        desId: "EP_EO_UI_41032",
        te: "",
        pad: "0 0 0 0",
        mgn: "0 0 0 0",
        isBrdr: true,
    }
}
export { SgiOverlapEO };
export default SgiOverlapEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiOverlapEO.js